import { Flex } from "antd";
import { FC } from "react";

import { SecondaryText } from "@/shared/ui/Typography";

import { StyledFinGroup } from "./Styled";

interface IFinGroups {
    finGroups: string[];
}

export const FinGroups: FC<IFinGroups> = ({ finGroups }) => {
    return (
        <Flex
            gap="12px"
            vertical
            align="flex-start"
            justify="flex-start"
            style={{ width: "100%", paddingBottom: 12 }}
        >
            <SecondaryText
                fontSize={14}
                fontWeight="400"
                lineHeight="140%"
                padding="0 0 0 20px"
            >
                Групи фін. обліку:
            </SecondaryText>

            {finGroups.map((group) => (
                <StyledFinGroup key={group}>{group}</StyledFinGroup>
            ))}
        </Flex>
    );
};
